import SelectFlowByBranch from './SelectFlowByBranch.vue'
import UpdateNotiLinaOA from './UpdateNotiLinaOA.vue'
import QueueSheet from './QueueSheet.vue'
import QueseBooking from './QueseBooking.vue'
export default {
  SelectFlowByBranch,
  UpdateNotiLinaOA,
  QueueSheet,
  QueseBooking
}



// WEBPACK FOOTER //
// ./src/components/OhRich/index.js